import { render, staticRenderFns } from "./PricingModal.vue?vue&type=template&id=38903a74&"
import script from "./PricingModal.vue?vue&type=script&lang=js&"
export * from "./PricingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports